import { Result } from "src/utils/Result"
import { deleteReservedMail } from "src/aws/customAPI"
import { execApi } from "src/apis/execApi"
import { appInfo } from "src/constants/AppInfo"

type DeleteContactParams = {
  accessToken: string
  reservedContactId: string
}

type DeleteContactSuccess = unknown

type DeleteContactFailure = {
  message: string
}

export const deleteReservedContact = async (params: DeleteContactParams): Promise<Result<DeleteContactSuccess, DeleteContactFailure>> => {
  const {accessToken, reservedContactId} = params

  return execApi(
    () => deleteReservedMail(accessToken, {
      input: {
        id: reservedContactId
      },
      appInfo
    }),
    _ => undefined,
    {
      identifiers: ["deleteReservedContact", "deleteReservedMail"],
      defaultErrorMessage: "送信予約の取り消しに失敗しました"
    }
  )
}
